import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'haleo-button-next',
    templateUrl: 'button-component.html',
    styleUrls: ['button-component.scss']
})
export class ButtonComponent {

    @Input() label: string;
    @Input() value: string | number;
    @Output() next: EventEmitter<any>;

    @Input() type: string;
    @Input() loading: boolean;
    @Input() disabled: boolean;

    constructor() {
        this.next = new EventEmitter<any>();
    }

    action() {

        if (this.type === 'next') {
            this.next.emit();
            return;
        }
    }
}
